module.exports = __webpack_public_path__ + "img/5_114.ea457c0b.png";